import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { createEmptyData } from 'constants/emptyData';
import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { checkError } from 'utils/api-helpers';
import { formatPrice } from 'utils/price-helpers';
import { constructQueryParams } from 'utils/query-params-builder';
import { ResponseOrderDto } from '../types/dtos';

export type OrdersWithJoinQueryParams = BaseQueryParams & {
    endUserId?: string;
    placeId?: string;
    orderStatus?: string;
    endUserFullName?: string;
};

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<PaginatedResponse<ResponseOrderDto>, OrdersWithJoinQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            if (!_arg.placeId) {
                return {
                    data: createEmptyData<ResponseOrderDto>(),
                };
            }

            const orderResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.ORDERS, _arg));
            const ordersError = checkError(orderResponse);
            if (ordersError) return ordersError;
            const orders = orderResponse.data as PaginatedResponse<ResponseOrderDto>;
            console.log(orders);

            let endUserFullName = '';

            orders.content = orders.content.map((order) => {
                if (order.endUser) {
                    endUserFullName = order.endUser.fullName;
                } else if (order.guestUser) {
                    endUserFullName = order.guestUser.fullName;
                }

                const totalPrice = order.totalPrice ? formatPrice(order.totalPrice) : '';

                return {
                    ...order,
                    endUserFullName,
                    totalPrice,
                };
            });

            return {
                data: orders,
            };
        },
        providesTags: [{ type: 'orders-with-join', id: 'GET-JOIN' }],
    });
